import { RootState } from 'src/redux/createRootReducer'

export const selectLoadingFromRemoteConfigState = (
  state: RootState,
): boolean | undefined => state.session.remoteConfig.loadingConfig

export const selectLoadedFromRemoteConfigState = (
  state: RootState,
): boolean | undefined => state.session.remoteConfig.loadedConfig

export const selectOrgIntegrationBetaOrgsFromRemoteConfigState = (
  state: RootState,
): string[] | undefined => state.session.remoteConfig.netSuiteOrgs

export const selectBmoIntegrationsWhitelistFromRemoteConfigState = (
  state: RootState,
): string[] | undefined => state.session.remoteConfig.bmoIntegrationsWhitelist

export const selectPushToWalletWhitelistFromRemoteConfigState = (
  state: RootState,
): string[] | undefined => state.session.remoteConfig.pushToWalletWhitelist

export const selectExpensePolicyAIWhitelistFromRemoteConfigState = (
  state: RootState,
): string[] | undefined =>
  state.session.remoteConfig.show_expense_policy_ai_whitelist
